import { useState } from "react";
import {
    Col,
    Container,
    Modal,
    Row,
    Button,
    FloatingLabel,
    Form,
} from "react-bootstrap";
import NavBar from "../../Navbar/Navbar";
import "./CorporateTraining.css";
import Footer from "../../Footer/Footer";
import YouTube, { YouTubeProps } from "react-youtube";
import Chart from "../../../assets/img/Applied-Arts2.png";
import { Helmet } from "react-helmet";
import communication from "../../../assets/img/New-Pages/Corporate-Training/Communication-Skills-Enhancement.png";
import inclusivefutures from "../../../assets/img/New-Pages/Corporate-Training/Inclusive-Futures.png";
import breaking from "../../../assets/img/New-Pages/Corporate-Training/Breaking-Barriers.png";
import empowered from "../../../assets/img/New-Pages/Corporate-Training/Empowered-Hiring.png";
import mental from "../../../assets/img/New-Pages/Corporate-Training/Mental-Health-Awareness-at-Work.png";
import inclusive from "../../../assets/img/New-Pages/Corporate-Training/Inclusive-Customer-Experience.png";




export default function CorporateTraining() {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const onPlayerReady = (event) => {
        // access to player in all event handlers via event.target
        event.target.pauseVideo();
    };
    const opts = {
        height: "590",
        width: "100%",
        playerVars: {
            autoplay: true,
        },
    };
    return (
        <>
            <Helmet>
                <title>
                    Child Skills Development | Manzil Center -Special Families Support
                </title>
                <meta
                    name="description"
                    content="Manzil students who are enrolled in the training program have access to the following services: Numeracy Enhancement, Communication Skills, etc."
                />
                <meta
                    name="keywords"
                    content="Manzil center, Special Family Support, Child skills development, special need school, Autism Center in Sharjah, NGO in Sharjah, Sharjah, UAE, special EMPLOYMENT PROGRAM in sharjah"
                />
                <link
                    rel="canonical"
                    href="https://www.manzil.ae/child-skill-development"
                />
                <meta
                    property="og:title"
                    content="Child Skills Development | Manzil Center -Special Families Support"
                />
                <meta
                    property="og:description"
                    content="Manzil students who are enrolled in the training program have access to the following services: Numeracy Enhancement, Communication Skills, etc."
                />
                <meta
                    property="og:url"
                    content="https://www.manzil.ae/child-skill-development"
                />
                <meta
                    property="og:image"
                    content="https://www.manzil.ae/static/media/Applied-Arts2.3e5603f92264d116fb7b.png"
                />
                <meta
                    name="twitter:title"
                    content="Child Skills Development | Manzil Center -Special Families Support"
                />
                <meta
                    name="twitter:description"
                    content="Manzil students who are enrolled in the training program have access to the following services: Numeracy Enhancement, Communication Skills, etc."
                />
                <meta
                    name="twitter:image"
                    content="https://www.manzil.ae/static/media/Applied-Arts2.3e5603f92264d116fb7b.png"
                />
            </Helmet>
            <NavBar />
            <div className="page-title-area child-inner">
                <div className="container-fluid h-100 d-flex justify-content-center align-items-center">
                    <div className="page-title-content">
                        <ul>
                            {/* <li>
                <a href="/">Home</a>
              </li> */}
                            <li>
                                <h1>Corporate Training</h1>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <Container className="mt-4 pt-2 pb-lg-3">

                <Row>
                    <Col lg={12} className="text-center">
                        <div className="main-heading">
                            {/* <span className="center">Child Skill Development</span> */}
                            <p className="mb-0">
                                Every student at Manzil follows an individual learning plan
                                (ILP). The training program follows a holistic approach
                                comprising development of emotional intelligence, academic,
                                self-help, cognitive, social, and motor skills primarily through
                                the medium of art
                            </p>
                        </div>
                    </Col>
                    {/* <Col lg={12}>
            <div className="main-heading mt-5">
              <span>Manzil Art Collection</span>

              <p>
                Manzil Art Collection displayed in prestigious art studio and
                hotels in Dubai
              </p>
            </div>
          </Col> */}
                    <Col lg={12}>
                        <div className="main-heading text-center mt-5">
                            <span className="center">Corporate Training Services</span>
                            <p><b>Empowering Inclusive Workplaces Through Meaningful Training</b></p>
                            <p>
                                Our expert-led training series enables organizations to embed inclusive values into their daily operations, transforming workplaces into environments where diversity thrives and all employees feel seen, valued, and supported.
                            </p>
                        </div>





                    </Col>

                    <div className="col-lg-4 mb-4">
                        <div className="corporate-traning-card">
                            <div>
                                <img
                                    src={communication}
                                    className="img-fluid"
                                    alt="United Nations Zero Project Award"
                                />


                                <h5 className="mb-2 mt-3">
                                    <span>Communication Skills Enhancement</span>
                                </h5>
                                <p className="mb-0">Build inclusive communication strategies that respect neurodiversity, varied learning styles, and accessible language.
                                </p>
                            </div>



                        </div>

                    </div>

                    <div className="col-lg-4 mb-4">
                        <div className="corporate-traning-card">
                            <div>
                                <img
                                    src={inclusivefutures}
                                    className="img-fluid"
                                    alt="United Nations Zero Project Award"
                                />


                                <h5 className="mb-2 mt-3">
                                    <span>Inclusive Futures: Embracing Varied Abilities</span>
                                </h5>
                                <p className="mb-0"> Learn how to integrate disability inclusion into your organizational culture, embracing each individual's unique strengths.
                                </p>
                            </div>



                        </div>

                    </div>

                    <div className="col-lg-4 mb-4">
                        <div className="corporate-traning-card">
                            <div>
                                <img
                                    src={breaking}
                                    className="img-fluid"
                                    alt="United Nations Zero Project Award"
                                />


                                <h5 className="mb-2 mt-3">
                                    <span>Breaking Barriers: Implementing Real DEI</span>
                                </h5>
                                <p className="mb-0">Develop practical strategies that go beyond theory, driving tangible DEI outcomes across leadership, HR, and team interactions.
                                </p>
                            </div>



                        </div>

                    </div>

                    <div className="col-lg-4 mb-4">
                        <div className="corporate-traning-card">
                            <div>
                                <img
                                    src={empowered}
                                    className="img-fluid"
                                    alt="United Nations Zero Project Award"
                                />


                                <h5 className="mb-2 mt-3">
                                    <span>Empowered Hiring: Inclusive Recruitment Strategies</span>
                                </h5>
                                <p className="mb-0">Master bias-free recruitment practices, improve candidate engagement, and increase retention through inclusive hiring.
                                </p>
                            </div>



                        </div>

                    </div>

                    <div className="col-lg-4 mb-4">
                        <div className="corporate-traning-card">
                            <div>
                                <img
                                    src={mental}
                                    className="img-fluid"
                                    alt="United Nations Zero Project Award"
                                />


                                <h5 className="mb-2 mt-3">
                                    <span>Mental Health Awareness at Work</span>
                                </h5>
                                <p className="mb-0">Equip leaders and teams with tools to create psychologically safe spaces and address mental well-being proactively.
                                </p>
                            </div>



                        </div>

                    </div>

                    <div className="col-lg-4 mb-4">
                        <div className="corporate-traning-card">
                            <div>
                                <img
                                    src={inclusive}
                                    className="img-fluid"
                                    alt="United Nations Zero Project Award"
                                />


                                <h5 className="mb-2 mt-3">
                                    <span>Inclusive Customer Experience</span>
                                </h5>
                                <p className="mb-0">Deliver service excellence by integrating accessibility, empathy, and inclusivity into every customer interaction.
                                </p>
                            </div>



                        </div>

                    </div>


                </Row>
            </Container>
            <Footer />
            {/* <Button variant="primary" onClick={handleShow} className='enquiry-btn default-btn-orange border-0 px-3'>
        Enquiry
      </Button> */}

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Enquiry Form</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Col lg={12}>
                            <FloatingLabel
                                controlId="floatingInput"
                                label="Name"
                                className="mb-3"
                            >
                                <Form.Control type="text" placeholder="Name" />
                            </FloatingLabel>
                        </Col>
                        <Col lg={12}>
                            <FloatingLabel
                                controlId="floatingPassword"
                                label="Email"
                                className="mb-3"
                            >
                                <Form.Control type="text" placeholder="Email" />
                            </FloatingLabel>
                        </Col>
                        <Col lg={12}>
                            <FloatingLabel
                                controlId="floatingPassword"
                                label="Phone"
                                className="mb-3"
                            >
                                <Form.Control type="text" placeholder="Phone" />
                            </FloatingLabel>
                        </Col>

                        <Col lg={12}>
                            <FloatingLabel
                                controlId="floatingTextarea2"
                                label="Message"
                                className="mb-3"
                            >
                                <Form.Control
                                    as="textarea"
                                    placeholder="Leave a comment here"
                                    style={{ height: "100px" }}
                                />
                            </FloatingLabel>
                        </Col>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" className="default-btn-orange border-0">
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
